<template>
    <div class="body">
        <edit></edit>
    </div>
</template>
  
<script>
import edit from "@/components/friendlyComponens/edit.vue";

export default {
    components: {
        edit,
    },
};
</script>
  